/**
 * Whether a purchase record is something an admin granted in the app (Mark as
 * paid, Grant VIP, Add pass, a child marked paid), as opposed to something
 * somebody paid for: Stripe, Eventbrite, or a pooled ticket a captain bought.
 *
 * Admins may take back only what was granted. A payment is undone by
 * refunding it in Stripe, which marks the record refunded; deleting the
 * record would leave the member unpaid while the money stays taken.
 */
export function isAdminGrant(purchase: { orderId?: unknown, eventbriteOrderId?: unknown, pooled?: unknown } | null | undefined): boolean {
  if (!purchase || purchase.pooled === true) return false
  const adminId = (id: unknown) => typeof id === 'string' && id.startsWith('admin-')
  return adminId(purchase.orderId) || adminId(purchase.eventbriteOrderId)
}
